import { useMutation } from '@connectrpc/connect-query'
import * as DomainModel from 'poc-ai-biz-irdb_domain-model'
import { createUser, getUserByCognitoUserId } from '../../../../proto/_gen/_gen.user.service-UserService_connectquery'
import { useAuth } from '../authService'
import { useLoggingMemo } from '../utils'
import { errorValidatedQueryResult, validatedQueryResult, ValidatedQueryResult } from './_shared/results'
import { convertUserToDomainModel } from '../../../../proto/_gen.converters'
import { useMemoizedQuery } from './_shared/connect'

export const useBackendApiCreateUser = () => {
  return useMutation(createUser)
}

export const useBackendApiGetUser = (): ValidatedQueryResult<DomainModel.User> => {
  const auth = useAuth()
  const query = useMemoizedQuery(
    getUserByCognitoUserId,
    { cognitoUserId: auth.isAuthenticated ? auth.cognitoUserId : undefined },
    {
      enabled: auth.isAuthenticated,
    },
  )
  return useLoggingMemo(
    () => {
      return validatedQueryResult(query.data?.user ? convertUserToDomainModel(query.data.user) : undefined, query)
    },
    [query],
    'useBackendApiGetUser',
  )
}

/** ログイン中の Cognito の利用者が、backend の利用者として登録されていないか */
export const useIsSignedInUserUnregistered = (): boolean => {
  const auth = useAuth()
  const query = useMemoizedQuery(
    getUserByCognitoUserId,
    { cognitoUserId: auth.isAuthenticated ? auth.cognitoUserId : undefined },
    {
      enabled: auth.isAuthenticated,
    },
  )
  return query.isSuccess && !query.data?.user
}
